export const BRAND = {
  name: "CEQVet",
  fullName: "Centro Quirúrgico Veterinario",
  city: "Copiapó, Chile",
  phone: "+56 9 7633 8018",
  phoneRaw: "56976338018",
  whatsappMsg: "Hola CEQVet, me gustaría agendar una hora para mi mascota.",
  email: "ceqvet.copiapo@gmail.com",
  address: "Luis Flores 483, Copiapó",
  instagram: "ceqvet",
  instagramUrl: "https://instagram.com/ceqvet",
  mapsEmbed:
    "https://www.google.com/maps?q=Luis+Flores+483,+Copiap%C3%B3,+Chile&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Luis+Flores+483+Copiap%C3%B3",
  hours: [
    { day: "Lunes a Viernes", time: "09:00 – 20:00" },
    { day: "Sábado", time: "10:00 – 18:00" },
    { day: "Domingo", time: "Solo urgencias" },
  ],
};

export const whatsappLink = (msg = BRAND.whatsappMsg) =>
  `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(msg)}`;

export const MEDIA = {
  hero: "https://images.unsplash.com/photo-1770836037793-95bdbf190f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHx2ZXRlcmluYXJpYW4lMjBkb2clMjBleGFtfGVufDB8fHx8MTc3ODYyNTIxNHww&ixlib=rb-4.1.0&q=85",
  about:
    "https://images.unsplash.com/photo-1746021375258-79fa1464ca1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHx2ZXRlcmluYXJ5JTIwY2xpbmljJTIwaW50ZXJpb3IlMjBtb2Rlcm58ZW58MHx8fHwxNzc4NjI1MjE0fDA&ixlib=rb-4.1.0&q=85",
  gallery: [
    {
      url: "https://customer-assets.emergentagent.com/job_cqvet-premium/artifacts/ksnu96gt_8ddc9e0d-0653-4952-8f96-3500b707fa7e.jpeg",
      caption: "Hospitalización",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cqvet-premium/artifacts/zf750jcr_ea2f4df5-ab20-4239-b287-50ca3f162291.jpeg",
      caption: "Sala de monitoreo y anestesia",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_cqvet-premium/artifacts/hsg8q0vl_2e9b2d02-5857-463a-8e7a-2f41a75affc2.jpeg",
      caption: "Laboratorio clínico",
    },
  ],
};

export const SERVICES = [
  {
    id: "medicina-general",
    title: "Medicina general",
    desc: "Controles, chequeos preventivos y atención clínica integral.",
    icon: "Stethoscope",
  },
  {
    id: "cirugia",
    title: "Cirugía veterinaria",
    desc: "Pabellón quirúrgico equipado para procedimientos seguros.",
    icon: "Scissors",
  },
  {
    id: "traumatologia",
    title: "Traumatología",
    desc: "Diagnóstico y tratamiento de fracturas y lesiones óseas.",
    icon: "Bone",
  },
  {
    id: "hospitalizacion",
    title: "Hospitalización",
    desc: "Monitoreo y cuidado continuo en una sala cálida y limpia.",
    icon: "BedDouble",
  },
  {
    id: "vacunacion",
    title: "Vacunación",
    desc: "Calendario de vacunas y prevención para cada etapa de vida.",
    icon: "Syringe",
  },
  {
    id: "ecografia",
    title: "Ecografía",
    desc: "Diagnóstico por imágenes preciso y no invasivo.",
    icon: "Activity",
  },
  {
    id: "laboratorio",
    title: "Laboratorio clínico",
    desc: "Análisis de sangre y exámenes con resultados rápidos.",
    icon: "FlaskConical",
  },
  {
    id: "peluqueria",
    title: "Peluquería",
    desc: "Baño, corte y estética para que tu mascota luzca y se sienta mejor.",
    icon: "Bath",
  },
];

export const TESTIMONIALS = [
  {
    name: "Camila Rojas",
    pet: "Tutora de Luna 🐶",
    text: "Atendieron a Luna con cariño y profesionalismo. El equipo explica todo con calma y se nota la experiencia.",
    rating: 5,
  },
  {
    name: "Felipe Araya",
    pet: "Tutor de Milo 🐱",
    text: "Llegué de urgencia un domingo y me atendieron rápidamente. Las instalaciones son modernas y limpias.",
    rating: 5,
  },
  {
    name: "Daniela Pérez",
    pet: "Tutora de Rocco 🐕",
    text: "La cirugía de Rocco fue impecable. El seguimiento post-operatorio fue clave para su recuperación.",
    rating: 5,
  },
  {
    name: "Matías Vergara",
    pet: "Tutor de Nala 🐈",
    text: "Excelente trato humano. Se preocupan tanto del paciente como del tutor. 100% recomendados.",
    rating: 5,
  },
];
